<template>
  <div>
    <template v-for="item in menu">
      <template v-if="!item.hidden && !item.permission">
        <el-submenu  :key="item.id" v-if="item.children && item.children.length>0" :index="(item.meta && item.path) || ('/'+item.routeUrl) ">
          <template slot="title">
            <!-- 引用 @/assets/svg/目录下的svg图标  svg-form   对应@/assets/svg/form.svg--> 
            <i v-if="item.icon&&item.icon.match(/^svg[\s-]/)" ><svg-icon :icon-class="item.icon.replace(/^svg[\s-](?:svg-)?/,'')" /></i>
            <i v-else :class="item.icon || 'el-icon-document'" />
            <span>{{ (item.meta && item.meta.title) || item.name }}</span>
          </template>
          <!--递归显示-->
          <menu-item :menu="item.children" />
        </el-submenu>
        <el-menu-item  :key="item.id" v-else :index="(item.meta && item.path) || ('/'+item.routeUrl)">
          <i v-if="item.icon&&item.icon.match(/^svg[\s-]/)" ><svg-icon :icon-class="item.icon.replace(/^svg[\s-](?:svg-)?/,'')" /></i>
          <i v-else :class="item.icon || 'el-icon-document'" />
          <span slot="title">{{ (item.meta && item.meta.title) || item.name }}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: "MenuItem",
  props: {
    menu: {
      type: Array,
      required: true
    }
  }
};
</script>

